import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import FormRadio from "@components/Form/FormRadio";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import { withFilterSectionRange } from "./withFilterSectionRange";

type ButtonProps = {
  active: boolean;
};

const List = tw.ul`
  block list-none py-midi
`;

const ListItem = tw.li`
  flex items-center
`;

const Button = withFocusRing(
  styledWithInvalidProps("button")(({ active }: ButtonProps) => [
    tw`block text-body leading-h4 flex items-center`,
    active ? tw`underline` : tw`hover:underline`,
  ]),
);

const Radio = tw(FormRadio)`
  h-maxi
`;

const Label = tw.p`
`;

const EmptyFilterLabel = tw.p`
  text-quaternary
`;

export const FilterSectionRange = withFilterSectionRange(
  ({ options, handleChange, handleScroll }) => {
    return (
      <List>
        {!options.length ? (
          <EmptyFilterLabel>No products found</EmptyFilterLabel>
        ) : null}
        {options?.map(({ key, checked }) => (
          <ListItem key={key.toString()} onClick={handleScroll}>
            <Button active={checked} onClick={handleChange(key)}>
              <Radio
                key={key}
                value={checked}
                internalState
                tabIndex={-1}
                name={key}
              />
              <Label>{key}</Label>
            </Button>
          </ListItem>
        ))}
      </List>
    );
  },
);
